import React from 'react';
import DashboardLayout from '../components/DashboardLayout';
import DocumentCenter from '../components/DocumentCenter';

const MyDocumentsPage = () => (
  <DashboardLayout>
    <div data-testid="my-documents-page">
      <DocumentCenter
        title="My Documents"
        subtitle="Upload and manage your required documents. Only you and authorized staff can access them."
      />
    </div>
  </DashboardLayout>
);

export default MyDocumentsPage;
